module.exports = __webpack_public_path__ + "img/brain_planet.2836cba1.svg";